import { useCallback, useState } from 'react'

// ///////////////////////
// MARK: TYPES
type TState = boolean
type TReturn = [
  state: TState,
  show: () => void,
  hide: () => void,
  toggle: () => void,
  setState: React.Dispatch<React.SetStateAction<TState>>,
]

// ///////////////////////
// MARK: EXPORTS
export function useStateToggle(defaultValue?: TState | (() => TState)): TReturn {
  const [state, setState] = useState<TState>(defaultValue ?? false)

  const show = useCallback<TReturn['1']>(() => setState(true), [])
  const hide = useCallback<TReturn['2']>(() => setState(false), [])
  const toggle = useCallback<TReturn['3']>(() => setState((v) => !v), [])

  return [state, show, hide, toggle, setState]
}
